export function SidebarHeader() {
  return (
    <div className="sticky top-0 z-10 mb-8 bg-white pb-6 pl-5">
      <div className="mt-5">
        <img src="/images/logo.png" width={120} height={120} alt="Musicalee" />
      </div>
    </div>
  );
}
